import React from "react";
import { Switch, Route } from "react-router-dom";
import ProtectAdmin from "../components/other/ProtectAdmin";
import NotificationProvider from "../context/NotificationContext";
import AdminAddCategory from "../pages/admin/AddCategory";
import AdminAddProducts from "../pages/admin/AddProducts";
import AdminCategories from "../pages/admin/Category";
//pages
import AdminDashboard from "../pages/admin/Dashboard";
import AdminEditOrders from "../pages/admin/EditOrders";
import AdminEditProducts from "../pages/admin/EditProducts";
import AdminOrders from "../pages/admin/Orders";
import AdminProducts from "../pages/admin/Products";
import AdminSignin from "../pages/admin/Signin";
import AdminSignup from "../pages/admin/Signup";

const Admin = () => {
  return (
    <div>
      <NotificationProvider>
        <Switch>
          <Route path="/admin/signin" component={AdminSignin} />
          <Route path="/admin/signup" component={AdminSignup} />
          <ProtectAdmin
            path="/admin/orders/:orderid"
            component={AdminEditOrders}
          />
          <ProtectAdmin path="/admin/orders" component={AdminOrders} />
          <ProtectAdmin
            exact
            path="/admin/categories"
            component={AdminCategories}
          />
          <ProtectAdmin
            path="/admin/categories/add"
            component={AdminAddCategory}
          />
          <ProtectAdmin
            path="/admin/products/:productid/edit/"
            component={AdminEditProducts}
          />
          <ProtectAdmin
            path="/admin/products/add/"
            component={AdminAddProducts}
          />
          <ProtectAdmin
            exact
            path="/admin/products"
            component={AdminProducts}
          />

          <ProtectAdmin path="/admin/" component={AdminDashboard} />
        </Switch>
      </NotificationProvider>
    </div>
  );
};

export default Admin;
